import { Coding } from "@medplum/fhirtypes";

import rawLoincCodeClassLookup from "./loinc-code-class-lookup.json";
import rawLoincClassDisplayLookup from "./loinc-class-display-lookup.json";

export type LoincClassType = "1" | "2" | "3" | "4";

type LoincCodeClassLookup = Record<string, { class: string; classType: LoincClassType }>;

type LoincClassDisplayLookup = Record<string, { displayValue: string; partCode: string }>;

const loincCodeClassLookup = rawLoincCodeClassLookup as LoincCodeClassLookup;
const loincClassDisplayLookup = rawLoincClassDisplayLookup as LoincClassDisplayLookup;

export type LoincClass = keyof LoincClassDisplayLookup;

export function isLoincCoding(coding: Coding): boolean {
  return coding.system === "http://loinc.org";
}

export function getLoincCodeClass(
  loincCode: string
): { abbreviation: string; display: string } | undefined {
  const classLookup = loincCodeClassLookup[loincCode];
  if (!classLookup) {
    return undefined;
  }
  const classDisplayLookup = loincClassDisplayLookup[classLookup.class];
  if (!classDisplayLookup) {
    return undefined;
  }

  return {
    abbreviation: classLookup.class,
    display: classDisplayLookup.displayValue,
  };
}
